import { Flex, Text, Spinner } from '@radix-ui/themes';
import { useChangelogRelease } from './useChangelogReleases';
import ReleaseCard from './ReleaseCard';
import styles from './Changelog.module.css';

const ChangelogReleaseShow = ({ routeData }) => {
  const { release, isLoading, error } = useChangelogRelease(routeData?.id);

  if (isLoading) {
    return (
      <div className={styles.loading}>
        <Spinner size="3" />
      </div>
    );
  }

  if (error || !release) {
    return (
      <div className={styles.emptyState}>
        <Text>Release not found.</Text>
      </div>
    );
  }

  return (
    <Flex direction="column" className={styles.container}>
      <div className={styles.backLink}>
        <a href="/client_admin/changelog">
          <i className="fa-solid fa-arrow-left" /> Back to Changelog
        </a>
      </div>

      <ReleaseCard release={release} canEdit={false} />
    </Flex>
  );
};

export default ChangelogReleaseShow;
